import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiFetch } from "@packages/core-client/api/apiFetch.ts";
import { queryPath } from "@packages/core-client/query/queryKeys.ts";
import { useEnvironmentVariable } from "@squide/firefly";
import { useMemo } from "react";
import { authContract } from "#shared/authContract.ts";

function createAuthClient(baseUrl: string) {
    const link = new OpenAPILink(authContract, {
        url: `${baseUrl}/api/auth`,
        fetch: apiFetch
    });

    const client: ContractRouterClient<typeof authContract> = createORPCClient(link);

    return createTanstackQueryUtils(client, { path: queryPath("shell", ["session"]) });
}

export function useAuthClient() {
    const apiBaseUrl = useEnvironmentVariable("apiBaseUrl");

    return useMemo(() => createAuthClient(apiBaseUrl), [apiBaseUrl]);
}
